export default "__VITE_ASSET__ClgxGZRF__"